import { hasValue } from '../../lib/utils';

export interface Name extends Record<string, unknown> {
	firstName: string;
	lastName: string;
}

export default interface FullName extends Name {
	middleNames?: string;
}

export const hasSingleName = (name: Name) => {
	return !hasValue(name.lastName);
};

export const getFirstNameAndLastNameOrSingleName = (name: Name) => {
	return hasSingleName(name) ? name.firstName : `${name.firstName} ${name.lastName}`;
};

export const getFullNameString = (fullName: FullName) => {
	const parts = [fullName.firstName, fullName.middleNames, fullName.lastName];
	return parts.filter((x) => hasValue(x)).join(' ');
};
